/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { doc, setDoc, addDoc, onSnapshot, collection, query, where, getDocs } from 'firebase/firestore';

const ANIO_ACTUAL = new Date().getFullYear();

function BarraReto({ leidos, objetivo, compact = false }) {
  const pct = Math.min((leidos / objetivo) * 100, 100);
  const completado = leidos >= objetivo;

  if (compact) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ flex: 1, height: '4px', background: '#1a1a1a', borderRadius: '4px', overflow: 'hidden' }}>
          <div style={{ height: '100%', width: `${pct}%`, background: completado ? '#FFD700' : '#1DB954', borderRadius: '4px', transition: '0.6s ease' }} />
        </div>
        <span style={{ fontSize: '11px', color: completado ? '#FFD700' : '#1DB954', fontWeight: 'bold', flexShrink: 0 }}>
          {leidos}/{objetivo}
        </span>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '8px' }}>
        <div>
          <span style={{ fontSize: '36px', fontWeight: 900, color: completado ? '#FFD700' : 'white' }}>{leidos}</span>
          <span style={{ fontSize: '18px', color: '#555', marginLeft: '4px' }}>/ {objetivo}</span>
        </div>
        <span style={{ fontSize: '13px', color: completado ? '#FFD700' : '#1DB954', fontWeight: 'bold' }}>
          {completado ? '🏆 ¡Completado!' : `${Math.round(pct)}%`}
        </span>
      </div>
      <div style={{ height: '8px', background: '#1a1a1a', borderRadius: '8px', overflow: 'hidden', marginBottom: '8px' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: completado ? 'linear-gradient(90deg, #FFD700, #FFA500)' : 'linear-gradient(90deg, #1DB954, #15a044)', borderRadius: '8px', transition: '0.8s ease', boxShadow: completado ? '0 0 10px #FFD70066' : '0 0 8px #1DB95466' }} />
      </div>
      {!completado && (
        <p style={{ fontSize: '12px', color: '#444', margin: 0 }}>
          {objetivo - leidos === 1 ? '¡Solo te falta 1 libro!' : `Te faltan ${objetivo - leidos} libros para tu objetivo`}
        </p>
      )}
    </div>
  );
}

function SelectorObjetivo({ onConfirmar, objetivoActual }) {
  const [objetivo, setObjetivo] = useState(objetivoActual || 12);
  const opciones = [6, 12, 24, 36, 52, 100];

  return (
    <div>
      <p style={{ fontSize: '13px', color: '#555', margin: '0 0 14px' }}>
        ¿Cuántos libros quieres leer en {ANIO_ACTUAL}?
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
        {opciones.map(n => (
          <button key={n} onClick={() => setObjetivo(n)}
            style={{ background: objetivo === n ? '#1DB954' : '#141414', color: objetivo === n ? 'black' : '#555', border: `1px solid ${objetivo === n ? '#1DB954' : '#2a2a2a'}`, borderRadius: '20px', padding: '8px 16px', fontWeight: objetivo === n ? 'bold' : 'normal', cursor: 'pointer', fontSize: '14px', transition: '0.2s' }}>
            {n}
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
        <span style={{ fontSize: '13px', color: '#555' }}>O elige tú:</span>
        <input type="number" min="1" max="365" value={objetivo}
          onChange={e => setObjetivo(Math.max(1, Math.min(365, parseInt(e.target.value) || 1)))}
          style={{ width: '70px', background: '#141414', border: '1px solid #2a2a2a', borderRadius: '8px', padding: '8px', color: 'white', textAlign: 'center', fontSize: '14px', outline: 'none' }} />
        <span style={{ fontSize: '13px', color: '#555' }}>libros</span>
      </div>
      <button onClick={() => onConfirmar(objetivo)} className="btn-verde">
        {objetivoActual ? 'Actualizar objetivo' : `Empezar el reto ${ANIO_ACTUAL}`}
      </button>
    </div>
  );
}

function IlustracionReto({ completado = false }) {
  const accent  = completado ? '#FFD700' : '#1DB954';
  const accent2 = completado ? '#FFA500' : '#4ade80';
  const accent3 = completado ? '#e0c050' : '#22c55e';
  const tapaTop = completado ? '#5c4500' : '#1a5c30';
  const tapaBtm = completado ? '#1a1200' : '#0a2814';
  const lomoD   = completado ? '#2a1f00' : '#0d3018';
  const lomoL   = completado ? '#5c4500' : '#1a5c30';
  const baseT   = completado ? '#3d2e00' : '#1a3d28';
  const baseB   = completado ? '#0a0800' : '#050e07';
  const bgColor = completado ? '#0f0a00' : '#0a0f0a';
  const auraC   = completado ? '#FFD700' : '#1DB954';
  const lineC   = completado ? '#a08840' : '#8a8070';

  return (
    <svg width="120" height="110" viewBox="0 0 240 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id={`aura-${completado}`} cx="50%" cy="55%" r="50%">
          <stop offset="0%"   stopColor={auraC} stopOpacity="0.6"/>
          <stop offset="45%"  stopColor={auraC} stopOpacity="0.22"/>
          <stop offset="100%" stopColor={auraC} stopOpacity="0"/>
        </radialGradient>
        <linearGradient id={`tapa-izq-${completado}`} x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%"   stopColor={tapaTop}/>
          <stop offset="100%" stopColor={tapaBtm}/>
        </linearGradient>
        <linearGradient id={`tapa-der-${completado}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor={tapaTop}/>
          <stop offset="100%" stopColor={tapaBtm}/>
        </linearGradient>
        <linearGradient id={`lomo-${completado}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%"   stopColor={lomoD}/>
          <stop offset="100%" stopColor={lomoL}/>
        </linearGradient>
        <linearGradient id={`base-${completado}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%"   stopColor={baseT}/>
          <stop offset="100%" stopColor={baseB}/>
        </linearGradient>
      </defs>


      <ellipse cx="120" cy="108" rx="105" ry="88" fill={`url(#aura-${completado})`}/>

      <path d="M40,108 A80,72 0 0,1 200,108" fill="none" stroke={accent} strokeWidth="1" strokeOpacity="0.18"/>
      <path d="M55,108 A65,58 0 0,1 185,108" fill="none" stroke={accent} strokeWidth="0.7" strokeOpacity="0.12"/>

      <ellipse cx="120" cy="162" rx="58" ry="10" fill="#000" opacity="0.55"/>
      <ellipse cx="120" cy="158" rx="64" ry="12" fill={`url(#base-${completado})`} opacity="0.9"/>
      <ellipse cx="120" cy="155" rx="60" ry="8"  fill={completado ? '#1a1000' : '#0f2a18'} opacity="0.7"/>

      <path d="M62,148 L62,82 Q62,76 68,74 L118,66 L118,132 Q118,138 112,140 Z" fill={tapaBtm} opacity="0.5"/>
      <path d="M178,148 L178,82 Q178,76 172,74 L122,66 L122,132 Q122,138 128,140 Z" fill={tapaBtm} opacity="0.5"/>

      <path d="M64,150 L64,84 Q64,78 70,76 L118,68 L118,134 Q118,140 112,142 Z" fill={`url(#tapa-izq-${completado})`}/>
      <path d="M64,150 L64,84 Q64,78 70,76 L118,68" fill="none" stroke={accent} strokeWidth="0.8" opacity="0.5"/>

      <path d="M176,150 L176,84 Q176,78 170,76 L122,68 L122,134 Q122,140 128,142 Z" fill={`url(#tapa-der-${completado})`}/>
      <path d="M176,150 L176,84 Q176,78 170,76 L122,68" fill="none" stroke={accent} strokeWidth="0.8" opacity="0.5"/>

      <path d="M68,147 L68,83 L118,70 L118,133 Z" fill="#c8c0a0" opacity="0.35"/>
      <path d="M70,146 L70,84 L118,71 L118,132 Z" fill="#ddd5b5" opacity="0.45"/>
      <path d="M72,145 L72,85 L118,72 L118,131 Z" fill="#f5f0e0"/>

      <line x1="80" y1="96"  x2="112" y2="88"  stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="80" y1="104" x2="112" y2="96"  stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="80" y1="112" x2="112" y2="104" stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="80" y1="120" x2="112" y2="112" stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="80" y1="128" x2="105" y2="121" stroke={lineC} strokeWidth="1.2" opacity="0.45"/>

      <path d="M172,147 L172,83 L122,70 L122,133 Z" fill="#c8c0a0" opacity="0.35"/>
      <path d="M170,146 L170,84 L122,71 L122,132 Z" fill="#ddd5b5" opacity="0.45"/>
      <path d="M168,145 L168,85 L122,72 L122,131 Z" fill="#f5f0e0"/>

      <line x1="128" y1="88"  x2="160" y2="96"  stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="128" y1="96"  x2="160" y2="104" stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="128" y1="104" x2="160" y2="112" stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="128" y1="112" x2="160" y2="120" stroke={lineC} strokeWidth="1.2" opacity="0.55"/>
      <line x1="128" y1="121" x2="153" y2="128" stroke={lineC} strokeWidth="1.2" opacity="0.45"/>

      <path d="M116,133 Q120,126 124,133 L124,70 Q120,63 116,70 Z" fill={`url(#lomo-${completado})`}/>
      <path d="M120,70 L120,133" stroke={accent} strokeWidth="0.6" opacity="0.4"/>

      <path d="M72,145 Q96,155 120,150 Q144,155 168,145" fill="none" stroke="#b8b098" strokeWidth="1.4" opacity="0.7"/>
      <path d="M64,150 Q92,162 120,157 Q148,162 176,150" fill="none" stroke={tapaTop} strokeWidth="1.2" opacity="0.6"/>

      <path d={`M76,44 L78,50 L84,52 L78,54 L76,60 L74,54 L68,52 L74,50 Z`} fill={accent}/>
      <path d={`M164,36 L165.8,41.5 L172,43.5 L165.8,45.5 L164,51 L162.2,45.5 L156,43.5 L162.2,41.5 Z`} fill={accent}/>
      <path d={`M50,88 L51.2,92 L55.5,93.5 L51.2,95 L50,99 L48.8,95 L44.5,93.5 L48.8,92 Z`} fill={accent2} opacity="0.85"/>
      <path d={`M192,80 L193,84 L197,85.5 L193,87 L192,91 L191,87 L187,85.5 L191,84 Z`} fill={accent2} opacity="0.85"/>
      <path d={`M120,26 L121.2,30 L125.5,31.5 L121.2,33 L120,37 L118.8,33 L114.5,31.5 L118.8,30 Z`} fill={accent3} opacity="0.7"/>
      <path d={`M96,32 L97,35 L100,36 L97,37 L96,40 L95,37 L92,36 L95,35 Z`} fill={accent} opacity="0.6"/>
      <path d={`M148,28 L149,31 L152,32 L149,33 L148,36 L147,33 L144,32 L147,31 Z`} fill={accent2} opacity="0.55"/>

      <rect x="58"  y="56"  width="6" height="6" fill={accent}  transform="rotate(45,61,59)"      opacity="0.9"/>
      <rect x="174" y="56"  width="5" height="5" fill={accent2} transform="rotate(45,176.5,58.5)" opacity="0.8"/>
      <rect x="42"  y="64"  width="4" height="4" fill={accent3} transform="rotate(45,44,66)"      opacity="0.6"/>
      <rect x="192" y="100" width="4" height="4" fill={accent}  transform="rotate(45,194,102)"    opacity="0.65"/>
      <rect x="108" y="16"  width="4" height="4" fill={accent2} transform="rotate(45,110,18)"     opacity="0.55"/>
      <rect x="136" y="14"  width="3" height="3" fill={accent}  transform="rotate(45,137.5,15.5)" opacity="0.5"/>
    </svg>
  );
}

export function RetoLector({ userId, compact = false, soloVer = false, enFeed = false }) {
  const [reto, setReto] = useState(null);
  const [leidosAnio, setLeidosAnio] = useState(0);
  const [retosCompletados, setRetosCompletados] = useState(0);
  const [configurando, setConfigurando] = useState(false);
  const [nuevoReto, setNuevoReto] = useState(false);

  useEffect(() => {
    if (!userId) return;
    const retoRef = doc(db, "retos", `${userId}_${ANIO_ACTUAL}`);
    const unsub = onSnapshot(retoRef, snap => {
      setReto(snap.exists() ? snap.data() : null);
    });
    return () => unsub();
  }, [userId]);

  useEffect(() => {
    if (!userId) return;
    const cargar = async () => {
      const [estadosSnap, historialSnap] = await Promise.all([
        getDocs(query(collection(db, "estados_lectura"), where("userId", "==", userId), where("estado", "==", "leido"))),
        getDocs(query(collection(db, "retos_historial"), where("userId", "==", userId))),
      ]);
      setLeidosAnio(estadosSnap.docs.filter(d => {
        const f = d.data().fecha?.toDate?.();
        return f && f.getFullYear() === ANIO_ACTUAL;
      }).length);
      const retoActualCompletado = reto && reto.objetivo && (() => {
        const base = reto.baseLeidos || 0;
        const progreso = leidosAnio - base;
        return progreso >= reto.objetivo;
      })();
      setRetosCompletados(historialSnap.docs.length + retoActualCompletado);
    };
    cargar();
  }, [userId, reto?.objetivo, reto?.baseLeidos]);

  const guardarReto = async (objetivo) => {
    if (!userId) return;
    if (nuevoReto && reto) {
      await addDoc(collection(db, "retos_historial"), {
        userId, anio: ANIO_ACTUAL, objetivo: reto.objetivo,
        baseLeidos: reto.baseLeidos || 0, fecha: new Date(),
      });
    }
    await setDoc(doc(db, "retos", `${userId}_${ANIO_ACTUAL}`), {
      userId, objetivo, anio: ANIO_ACTUAL, baseLeidos: leidosAnio, fecha: new Date(),
    });
    setConfigurando(false);
    setNuevoReto(false);
  };

  const base = reto?.baseLeidos || 0;
  const leidosReto = Math.max(0, leidosAnio - base);

  if (compact && reto) {
    return (
      <div style={{ background: '#0d1f10', borderRadius: '10px', padding: '10px 14px', border: '1px solid #1DB95433' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
          <span style={{ fontSize: '11px', color: '#1DB954', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Reto activo</span>
          {leidosReto >= reto.objetivo && <span style={{ fontSize: '11px', color: '#FFD700', fontWeight: 'bold' }}>🏆 Completado</span>}
        </div>
        <BarraReto leidos={leidosReto} objetivo={reto.objetivo} compact />
      </div>
    );
  }

  if (enFeed) {
    const completado = reto && leidosReto >= reto.objetivo;

    if (!reto || nuevoReto) return (
      <div style={{ background: 'linear-gradient(135deg, #0a1a0a, #111)', borderRadius: '16px', padding: '20px', border: '1px solid #1DB95433' }}>
        <p style={{ margin: '0 0 2px', fontSize: '11px', color: '#1DB954', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>Reto activo</p>
        <p style={{ margin: '0 0 16px', fontWeight: 900, fontSize: '18px', color: 'white' }}>Reto lector {ANIO_ACTUAL}</p>
        <SelectorObjetivo onConfirmar={guardarReto} objetivoActual={undefined} />
      </div>
    );

    const pct = Math.min(Math.round((leidosReto / reto.objetivo) * 100), 100);
    const col = completado ? '#FFD700' : '#1DB954';
    return (
      <div style={{ background: `linear-gradient(120deg, ${col}1f 0%, #0a0e0b 65%)`, borderRadius: '18px', border: `1px solid ${col}3a`, display: 'flex', alignItems: 'stretch', overflow: 'hidden', boxShadow: `0 8px 30px ${col}12` }}>
        <div style={{ flex: 1, minWidth: 0, padding: '20px 0 20px 20px' }}>
          <p style={{ margin: '0 0 2px', fontSize: '11px', color: col, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '1px', display: 'flex', alignItems: 'center', gap: '5px' }}>
            <span style={{ width: '14px', height: '14px', borderRadius: '4px', background: `${col}25`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill={col}><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
            </span>
            {completado ? 'Reto completado' : 'Reto activo'}
          </p>
          <p style={{ margin: '0 0 2px', fontWeight: 900, fontSize: '18px', color: 'white' }}>Reto lector {ANIO_ACTUAL}</p>
          <p style={{ margin: '0 0 10px', fontSize: '12px', color: '#555' }}>
            {completado ? `¡Has leído ${leidosReto} libros este año!` : `Lee ${reto.objetivo} libros este año`}
          </p>
          <div style={{ height: '5px', background: 'rgba(255,255,255,0.08)', borderRadius: '5px', overflow: 'hidden', marginBottom: '5px' }}>
            <div style={{ height: '100%', width: `${pct}%`, background: completado ? 'linear-gradient(90deg, #FFD700, #FFA500)' : 'linear-gradient(90deg, #1DB954, #4ade80)', borderRadius: '5px', boxShadow: `0 0 8px ${col}66`, transition: '0.8s ease' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <p style={{ margin: 0, fontSize: '12px', color: col, fontWeight: 'bold' }}>{leidosReto}/{reto.objetivo} libros</p>
            {completado && (
              <button onClick={() => { setNuevoReto(true); setConfigurando(true); }}
                style={{ background: `${col}22`, color: col, border: `1px solid ${col}44`, borderRadius: '20px', padding: '4px 12px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer' }}>
                Nuevo reto →
              </button>
            )}
          </div>
        </div>
        <div style={{ width: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, padding: '4px 4px 4px 0' }}>
          <IlustracionReto completado={completado} />
        </div>
      </div>
    );
  }

  if (!reto) {
    if (soloVer) return null;
    return (
      <div style={{ background: '#141414', borderRadius: '12px', padding: '20px', border: '1px solid #1e1e1e' }}>
        <p style={{ margin: '0 0 4px', fontWeight: 900, fontSize: '16px', color: 'white' }}>Reto lector {ANIO_ACTUAL}</p>
        <p style={{ color: '#555', fontSize: '13px', margin: '0 0 16px' }}>Ponte un objetivo de lectura para este año</p>
        {configurando
          ? <SelectorObjetivo onConfirmar={guardarReto} />
          : <button onClick={() => setConfigurando(true)} className="btn-verde">Empezar el reto</button>}
      </div>
    );
  }

  const completado = leidosReto >= reto.objetivo;

  return (
    <div style={{ background: completado ? 'linear-gradient(135deg, #1a1400, #141414)' : '#141414', borderRadius: '12px', padding: '20px', border: `1px solid ${completado ? '#FFD70033' : '#1e1e1e'}` }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <div>
          <p style={{ margin: '0 0 2px', fontWeight: 900, fontSize: '16px', color: 'white' }}>Reto lector {ANIO_ACTUAL}</p>
          <p style={{ margin: 0, fontSize: '12px', color: '#444' }}>
            {completado ? `¡Has leído ${leidosReto} libros este año!` : `${leidosReto} leídos de ${reto.objetivo}`}
          </p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {completado && (
            <button onClick={() => { setNuevoReto(true); setConfigurando(true); }}
              style={{ background: '#FFD70018', color: '#FFD700', border: '1px solid #FFD70033', borderRadius: '12px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}>
              Nuevo reto
            </button>
          )}
          {!soloVer && !completado && (
            <button onClick={() => setConfigurando(!configurando)}
              style={{ background: 'none', border: '1px solid #2a2a2a', color: '#555', borderRadius: '12px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}>
              {configurando ? 'Cancelar' : 'Editar'}
            </button>
          )}
        </div>
      </div>
      {retosCompletados > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '14px', background: '#FFD70010', borderRadius: '8px', padding: '6px 10px', width: 'fit-content' }}>
          <span style={{ fontSize: '14px' }}>🏆</span>
          <span style={{ fontSize: '11px', color: '#FFD700', fontWeight: 'bold' }}>{retosCompletados} reto{retosCompletados !== 1 ? 's' : ''} completado{retosCompletados !== 1 ? 's' : ''}</span>
        </div>
      )}
      {(configurando || nuevoReto) && !soloVer
        ? <SelectorObjetivo onConfirmar={guardarReto} objetivoActual={nuevoReto ? undefined : reto.objetivo} />
        : <BarraReto leidos={leidosReto} objetivo={reto.objetivo} />}
    </div>
  );
}
